// Attendez que la page soit complètement chargée
$(document).ready(function() {

  $('.cc-price-range__input-currency-symbol').text('DT');
  

  var number_special_color = $('#product-metafields').data('special-color');
  
  var id_special_color = $('.' + 'option-selector__btns').attr('id');

  var number_classic_color = parseInt(id_special_color.split('-').pop());

  var difference_number = number_special_color - number_classic_color ;

  if(number_classic_color){
  $('.option-selector__btns').css('display', 'grid');
  var newGridTemplateColumns = 'repeat(' + number_classic_color + ', 0fr)';
  $('.option-selector__btns').css('grid-template-columns', newGridTemplateColumns);

  
   var $firstSpecialColorRadio = $('.option-selector__btns input[type="radio"]:eq('+ number_classic_color + ')');
    $firstSpecialColorRadio.before('<legend class="label speciall_color" >Special Colors :</legend>');

    if(difference_number > 0){
        for (var i = 1; i <= difference_number; i++) {
      var newItem = $("<div class='grid-item'></div>");
      $('.option-selector__btns input[type="radio"]:eq('+ number_classic_color + ')').after(newItem);
           $('.option-selector__btns label:eq('+ number_classic_color + ')').before(newItem);
                $('.option-selector__btns input[type="radio"]:eq('+ number_classic_color + ')').before(newItem);

  }

  
    var number_classic_color_columns = number_special_color;
    var newGridTemplateColumns = 'repeat(' + number_classic_color_columns + ', 0fr)';
    $('.option-selector__btns').css('grid-template-columns', newGridTemplateColumns);
    }

  }



 /*  function changeVariantCompleteTheLookIfExist(checkboxValue) {
        var checkExist = setInterval(function() {
            if ($('.lb-upsell-product-page-card').length) {
                clearInterval(checkExist);
    
              setTimeout(function() {
                
        var specificString = checkboxValue;
    
        $('.lb-shared-variants-select option').each(function() {
            var optionValue = $(this).val();
    
            try {
                var parsedValue = JSON.parse(optionValue);
                var optionTitle = parsedValue.title;
    
                if (optionTitle.includes(specificString)) {
                    searchedValue = optionValue;
                    $('.lb-shared-variants-select').val(optionValue);
                    return false;
                }
            } catch (e) {
            }
        });
     
    }, 2000);
       
            }
        }, 100); // check every 100ms

   }*/


     function changeVariantCompleteTheLook(checkboxValue) {

            if ($('.lb-upsell-product-page-card').length) {
                
        var specificString = checkboxValue;
    
        $('.lb-shared-variants-select option').each(function() {
            var optionValue = $(this).val();
    
            try {
                var parsedValue = JSON.parse(optionValue);
                var optionTitle = parsedValue.title;
    
                if (optionTitle.includes(specificString)) {
                  console.log(parsedValue.featuredImageSrc);
                    searchedValue = optionValue;
                    $('.lb-shared-variants-select').val(optionValue);
                    $('.lb-spc-image').attr('src', parsedValue.featuredImageSrc);
                    return false;
                }
            } catch (e) {
            }
        });
       
            }


   }
  
    var urlLogo = $('.logo img').attr('src');
    
    $('.logo img').load(urlLogo, function() {
        $(this).find('path').css('fill', 'black');
        $('.logo img svg').addClass('svg-logo');
        
        $('.svg-logo').clone().appendTo($('.logo__link'));
        $('.logo img').css('margin-top', '-10px');
        $('.logo img').attr('src', '').css('height', '0');
        
        
        
        //********** Initi color **********
        
        var checkboxValue = $('.option-selector__btns input[type="radio"]:checked').val();
        //changeVariantCompleteTheLookIfExist(checkboxValue);
        var headerColor;

      
      // ********** here you can add new colors (BAR) **********//
        switch (checkboxValue) {
                            case 'Black':
                headerColor = '#000000';
                break;

                        case 'Brown':
                headerColor = '#6a3a38';
                break;
           
            
                        case 'Burgundy':
                headerColor = '#a52f3d';
                break;
             
            
                        case 'Khaki':
                headerColor = '#776948';
                break;
             
            
                        case 'Navy':
                headerColor = '#23305B';
                break;
              
                        case 'Blue':
                headerColor = '#a8bcd5';
                break;
            
            
                        case 'Green':
                headerColor = '#01de9b';
                break;
              
            
                        case 'Pink':
                headerColor = '#f180ab';
                break;
              
            
                        case 'Red':
                headerColor = '#FF0013';
                break;
             
                         case 'Lemonade':
                headerColor = '#ECE964';
                break;
             
            
                     case 'Beige':
                headerColor = '#F0C3A1';
                break;
            

                    case 'Radiant Pink':
                headerColor = '#FA45A2';
                break;

                    case 'Turquoise':
                headerColor = '#3198dd';
                break;
            
                    case 'Salmon':
                headerColor = '#e6af8f';
                break;

                    case 'Dusty Pink':
                headerColor = '#e3a4a7';
                break;

                   case 'Camel':
                headerColor = '#ce8c5b';
                break;

                  case 'Off-White':
                headerColor = '#e1dcd0';
                break;

                  case 'Orange':
                headerColor = '#f36303';
                break;

                  case 'Gold Lurex':
                headerColor = '#cfb390';
                break;

                  case 'Green Lurex':
                headerColor = '#84aa5d';
                break;

                  case 'Pink Lurex':
                headerColor = '#c47fad';
                break;

                  case 'Coral':
                headerColor = '#ff9c95';
                break;

                  case 'Neon Yellow':
                headerColor = '#e5fba4';
                break;

              case 'Silver Lurex':
                headerColor = '#8e8a8e';
                break;

              case 'Black Lurex':
                headerColor = '#211c1e';
                break;

              case 'Silver':
                headerColor = '#dedde5';
                break;

              case 'Dark Red:':
                headerColor = '#bd0026';
                break;

              case 'Purple Lurex:':
                headerColor = '#755c57';
                break;

              case 'Blue Lurex:':
                headerColor = '#0c2848';
                break;

              case 'Kelly Green:':
                headerColor = '#03b877';
                break;


                
            default:
                headerColor = '#000000';
        }
        
        //change color header
        var divElements = document.querySelectorAll('.announcement-bar.announcement-bar--with-announcement.cc-animate-init.cc-animate-in');
        divElements.forEach(function(div) {
            
            div.style.backgroundColor = headerColor;
        });

        
        //change color logo (svg)
        $('.svg-logo path').css('fill', headerColor);
        
        $('.logo img').css('margin-top', '-10px');
        $('.logo img').attr('src', '').css('height', '0');
        
        //change color logo (text)
        var logo = document.querySelectorAll('.logo__link');
        logo.forEach(function(a) {
            a.style.color = headerColor;
        });

        //change color add to cart button
        $('.add-to-cart').css({
            'background-color': headerColor,
            'border-color': headerColor
          });

        
      
        
        //********** change color when select radio box **********
      
        var radioInputs = document.querySelectorAll('.option-selector__btns input[type="radio"]');

            // ********** here you can add new colors BUTTONS **********//
        var colorMap = {
                   "Black": '#000000',
                   "Brown": '#6a3a38',
                   "Burgundy": '#a52f3d',
                   "Khaki": '#776948',
                   "Navy": '#23305B',
                   "Blue": '#a8bcd5',
                   "Green": '#01de9b',
                   "Pink": '#f180ab',
                   "Red": '#FF0013',
                  "Lemonade": '#ECE964',
                  "Beige": '#F0C3A1',
                  "Radiant Pink": '#FA45A2',
                  "Turquoise": '#3198dd',
                  "Salmon": '#e6af8f',
                  "Dusty Pink": '#e3a4a7',
                  "Camel": '#ce8c5b',
                  "Off-White": '#e1dcd0',
                  "Orange": '#f36303',
                  "Gold Lurex": '#cfb390',
                  "Green Lurex": '#84aa5d',
                  "Pink Lurex": '#c47fad',
                  "Coral": '#ff9c95',
                  "Neon Yellow": '#e5fba4',
                  "Silver Lurex": '#8e8a8e',                  
                  "Black Lurex": '#211c1e',                  
                  "Silver": '#dedde5',                  
                  "Dark Red": '#bd0026',  
                  "Purple Lurex": '#755c57',                  
                  "Blue Lurex": '#0c2848',                  
                  "Kelly Green": '#03b877',                  

      

        };
        
        radioInputs.forEach(function(input) {
            input.addEventListener('click', function() {
                var selectedVariantValue = input.value;
                var headerColor = colorMap[selectedVariantValue] || '#000000';
              
                // Loop through the object
                for (var key in colorMap) {
                    if (colorMap.hasOwnProperty(key)) {
                        if (colorMap[key] === headerColor) {
                            colorName = key;
                            //changeVariantCompleteTheLook(colorName);
                            break;
                        }
                    }
                }
                if (selectedVariantValue in colorMap) {

                    
                    //change color header
                    var divElements = document.querySelectorAll('.announcement-bar.announcement-bar--with-announcement.cc-animate-init.cc-animate-in');
                    divElements.forEach(function(div) {
                        div.style.backgroundColor = headerColor;
                    });

            
                    //change color logo (svg)
                    $('.svg-logo path').fadeTo(500, 0.5, function(){
                      $(this).css('fill', headerColor).slideDown(1000).fadeTo(500, 1);
                    });
                  
                    $('.svg-logo path').css('fill', headerColor);
                    
                    $('.logo img').css('margin-top', '-10px');
                    $('.logo img').attr('src', '').css('height', '0');

                    
                    //change color logo (text)
                    $('.logo__link').fadeTo(250, 0.5, function(){
                      $(this).css('color', headerColor).slideDown(500).fadeTo(250, 1);
                    });
                  
                    var logo = document.querySelectorAll('.logo__link');
                    logo.forEach(function(a) {
                        a.style.color = headerColor;
                    });


                  //change color add to cart button
                      $('.add-to-cart').fadeTo(250, 0.5, function(){
                           $(this).css({
                            'background-color': headerColor,
                            'border-color': headerColor
                          }).slideDown(500).fadeTo(250, 1);
                      });

                      $('.lb-spc-cta-common').fadeTo(250, 0.5, function(){
                         $(this).css({
                              'background-color': headerColor,
                              'border-color': headerColor
                            }).slideDown(500).fadeTo(250, 1);
                      });
                  
                }
            });
        });
        
        
    });
});
